app.component("aiPromptsView", {
	templateUrl: "app/src/js/components/aiPrompts/aiPrompts.html",
	controller: "aiPromptsController",
	bindings: {
		prompt: "=",
        resetPrompt: "&",
	},
});

app.controller("aiPromptsController", [
	"$scope",
	"$modal",
	"ElevenLabsAPI",
	"Session",
	"ELEVEN_LABS_AI_TOUR_1261",
	function ($scope, $modal, ElevenLabsAPI, Session, ELEVEN_LABS_AI_TOUR_1261) {

		$scope.API = ElevenLabsAPI;
		$scope.availablePrompts = [];

		$scope.popoverDelete = {
			content:
				"Delete",
		};

		$scope.popoverEdit = {
			content:
				"Edit",
		};


		this.$onInit = function () {
			if ($scope.$ctrl.prompt) {
				$scope.showEdit = true;
				$scope.promptObj = {
					prompt_id: $scope.$ctrl.prompt.prompt_id,
					name: $scope.$ctrl.prompt.name,
					content: $scope.$ctrl.prompt.content,
					preamble: $scope.$ctrl.prompt.preamble,
				};
				$scope.$ctrl.resetPrompt();
			} else {
				$scope.showEdit = false;
				$scope.promptObj = { name: '' }
				fetchPropmts();
			}

			$scope.$ctrl.resetPrompt();
		};

		function fetchPropmts() {
			$scope.API.isProcessing = true;
			$scope.API.getPrompts()
				.then(
					(resp) => {
						$scope.availablePrompts = resp.data;
					},
					(error) => {
						showGenericErrorModal();
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		}

		$scope.openDeleteModal = (item) => {
			$scope.negativeButton = null;
			$scope.onGeneralClick = function () {
				if ($scope.generalModal) {
					$scope.generalModal.hide();
					$scope.negativeButton = null;
				}
				deletePrompt(item);
			};
			$scope.generalModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.general.tpl.html",
				show: true,
				title: "Delete Prompt",
				content: "Are you sure you want to delete this AI Prompt?",
				backdrop: true,
				keyboard: false,
			});
		};

		function showGenericErrorModal() {
			if ($scope.serverErrorModal) {
				$scope.serverErrorModal.hide();
			}
			$scope.serverErrorModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
				show: true,
				title: "CatTrax has encountered an error",
				keyboard: false,
				backdrop: "static",
				onHide: function () {
					angular.element("body").removeClass("modal-open").css("overflow", "auto");
				},
			});
		}

		$scope.promptOptions = {
			height: 150,
			focus: true,
			disableResizeEditor: true,
			disableDragAndDrop: true,
			inheritPlaceholder: true,
			toolbar: []
		};

		$scope.preambleOptions = {
			height: 150,
			focus: false,
			disableResizeEditor: true,
			disableDragAndDrop: true,
			inheritPlaceholder: true,
			toolbar: []
		};

		$scope.dropped = function (dragEl, dropEl) {
			if (!dragEl || !dropEl) {
				return;
			}

			// lvl-drop-target reports the id of the element it is on, which is the
			// wrapper - the editor itself is "content" / "preamble" inside it.
			var editorId = dropEl.replace(/Container$/, "");
			var editor = angular.element("#" + editorId);
			var inserted = false;

			// Note: `editor.summernote` is always defined once the plugin is loaded,
			// so it cannot be used to tell a real editor from any other element.
			try {
				if (editor.length && editor.data("summernote")) {
					editor.summernote("editor.restoreRange");
					editor.summernote("editor.focus");
					editor.summernote("editor.insertText", dragEl + " ");
					inserted = true;
				}
			} catch (e) {
				inserted = false;
			}

			// Fall back to appending if the editor is not ready yet.
			if (!inserted) {
				if (editorId === "content") {
					$scope.promptObj.content = ($scope.promptObj.content || "") + " " + dragEl;
				} else if (editorId === "preamble") {
					$scope.promptObj.preamble = ($scope.promptObj.preamble || "") + " " + dragEl;
				}
			}

			$scope.$applyAsync();
		};

		$scope.editPrompt = (item) => {
			$scope.showEdit = true;
			$scope.promptObj = {
				prompt_id: item.prompt_id,
				name: item.name,
				content: item.content,
				preamble: item.preamble,
			};
		}

		$scope.goBack = () => {
			if ($scope.availablePrompts.length === 0) {
				fetchPropmts();
			}
			$scope.showEdit = false;
		}

		$scope.saveOrEditPrompt = () => {
			const data = {
				practice_id: Session.practice.id,
				name: $scope.promptObj.name,
				content: $scope.promptObj.content,
				preamble: $scope.promptObj.preamble,
			};

			$scope.API.isProcessing = true;
			let api = $scope.promptObj.prompt_id ? $scope.API.updatePrompt($scope.promptObj.prompt_id, data) : $scope.API.createPrompt(data);
			api.then(
				(resp) => {
					$scope.goBack();
					fetchPropmts();
				},
				(error) => showGenericErrorModal()
			).then(() => {
				$scope.API.isProcessing = false;
			});
		}

		$scope.createPrompt = () => {
			$scope.promptObj = { name: '' }
			$scope.showEdit = true;
			setTimeout(() => {
				setupOnboard();
			}, 1000);
		}

		function deletePrompt(item) {
			$scope.API.isProcessing = true;
			$scope.API.deletePrompt(item.prompt_id).then(
				(resp) => {
					fetchPropmts()
				},
				(error) => showGenericErrorModal()
			).then(() => {
				$scope.API.isProcessing = false;
			})
		}

		function setupOnboard() {
			if(!ELEVEN_LABS_AI_TOUR_1261){
                return;
            }
			introJs
				.tour()
				.setOptions({
					steps: [
						{
							title: "Add prompt name",
							element: document.getElementById("prompt_name"),
							intro: "This step focuses on an element",
						},
						{
							title: "Add prompt text",
							element: document.getElementById("contentContainer"),
							intro: "This step focuses on an element",
						},
						{
							title: "Add first message",
							element: document.getElementById("preambleContainer"),
							intro: "This step focuses on an element",
						},
					],
					tooltipClass: "intro-customTooltip",
					dontShowAgain: true,
					showBullets: false,
				})
				.onAfterChange(function (targetElement) {
					targetElement.scrollIntoView();
				})
				.start();
		}
	},
]);
